import React from 'react';

export const Unauthorized: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-3xl font-semibold text-gray-900">Unauthorized</h1>
        <p className="mt-2 text-gray-600">You are not authorised to view this page.</p>
      </div>
    </div>
  );
};





